module.exports = __webpack_public_path__ + "img/4de4228.gif";